"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcRegisterEntryHeader = class UcRegisterEntryHeader extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    entry;
    onEntry(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("entry");
    }
    selectRegister;
    onSelect_register(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("selectRegister");
    }
    messages;
    registerInfo;
    async $$load_registerInfo() {
        return {
            selectedRegisterId: this.entry.version.register_id,
            selectedVersionId: this.entry.version.version_id,
        };
    }
    ux;
    b_6917646200545441_style;
    b_6424600534600827_style;
    dataMembers = ['messages', 'registerInfo', 'ux', 'b_6917646200545441_style', 'b_6424600534600827_style'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                messages: {
                    newTransaction: this.$fn.pgettext("Register", "New entry"),
                },
                registerInfo: null,
                ux: null,
                b_6917646200545441_style: {
                    "font-size": "1em",
                },
                b_6424600534600827_style: {
                    "font-size": "1em",
                },
            },
        };
    }
    get resourceTitle() {
        if (this.loaded) {
            return !this.selectRegister && this.entry.version.name;
        }
        return null;
    }
    get resourceKey() {
        if (this.loaded) {
            return this.entry.isNew
                ? this.messages.newTransaction + ` - ${this.entry.entry_number}`
                : this.entry.entry_number;
        }
        return null;
    }
    async act_8358196963355853_script_8154_getActionArgs_value($event) {
        this.$emit('registerChanged', $event.data);
    }
    async act_8358196963355853_script_8154_getActionArgs($event) {
        return {
            value: () => this.act_8358196963355853_script_8154_getActionArgs_value($event),
        };
    }
    async evh_8358196963355853_input(event, scope) {
        return await this.actions.evh_8358196963355853_input.executeFromDOM(this, event, scope);
    }
    async act_4576710983066270_emit_8156_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_4576710983066270_clickPreventStop(event, scope) {
        return await this.actions.evh_4576710983066270_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_2124730035910225_emit_8160_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async act_2124730035910225_reloadSlickgrid_8162_getActionArgs($event) {
        return {
            grid: "register",
        };
    }
    async act_2124730035910225_request_8158_getActionArgs($event) {
        return {
            operation: "update_register_entry",
            data: {
                id: this.entry.id,
                etag: this.entry.etag,
                locked: true,
            },
        };
    }
    async evh_2124730035910225_clickPreventStop(event, scope) {
        return await this.actions.evh_2124730035910225_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_1972474632001399_emit_8166_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async act_1972474632001399_reloadSlickgrid_8168_getActionArgs($event) {
        return {
            grid: "register",
        };
    }
    async act_1972474632001399_request_8164_getActionArgs($event) {
        return {
            operation: "update_register_entry",
            data: {
                id: this.entry.id,
                etag: this.entry.etag,
                locked: false,
            },
        };
    }
    async evh_1972474632001399_clickPreventStop(event, scope) {
        return await this.actions.evh_1972474632001399_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_2383909669375364_emit_8172_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async act_2383909669375364_reloadSlickgrid_8174_getActionArgs($event) {
        return {
            grid: "register",
        };
    }
    async act_2383909669375364_request_8170_getActionArgs($event) {
        return {
            operation: "update_register_entry",
            data: {
                id: this.entry.id,
                etag: this.entry.etag,
                void: true,
            },
        };
    }
    async evh_2383909669375364_clickPreventStop(event, scope) {
        return await this.actions.evh_2383909669375364_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_2342151935932928_emit_8178_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async act_2342151935932928_reloadSlickgrid_8180_getActionArgs($event) {
        return {
            grid: "register",
        };
    }
    async act_2342151935932928_request_8176_getActionArgs($event) {
        return {
            operation: "update_register_entry",
            data: {
                id: this.entry.id,
                etag: this.entry.etag,
                void: false,
            },
        };
    }
    async evh_2342151935932928_clickPreventStop(event, scope) {
        return await this.actions.evh_2342151935932928_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_2498310591257107_emit_8182_getActionArgs($event) {
        return {
            event: "deleted",
        };
    }
    async evh_2498310591257107_success(event, scope) {
        return await this.actions.evh_2498310591257107_success.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_8358196963355853_script_8154 = new core_1.actions.ScriptAction({
            actionArgs: this.act_8358196963355853_script_8154_getActionArgs,
            events: [],
        });
        const evh_8358196963355853_input_8153 = new core_1.actions.EventHandlerImpl({
            action: act_8358196963355853_script_8154,
            event: "input",
            displayName: "script",
        });
        const evh_8358196963355853_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8358196963355853_input_8153],
        });
        const act_4576710983066270_emit_8156 = new core_1.actions.EmitAction({
            actionArgs: this.act_4576710983066270_emit_8156_getActionArgs,
            displayName: "reload",
            events: [],
        });
        const evh_4576710983066270_clickPreventStop_8155 = new core_1.actions.EventHandlerImpl({
            action: act_4576710983066270_emit_8156,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_4576710983066270_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4576710983066270_clickPreventStop_8155],
        });
        const act_2124730035910225_emit_8160 = new core_1.actions.EmitAction({
            actionArgs: this.act_2124730035910225_emit_8160_getActionArgs,
            events: [],
        });
        const evh_2124730035910225_success_8159 = new core_1.actions.EventHandlerImpl({
            action: act_2124730035910225_emit_8160,
            event: "success",
            displayName: "emit",
        });
        const act_2124730035910225_reloadSlickgrid_8162 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_2124730035910225_reloadSlickgrid_8162_getActionArgs,
            events: [],
        });
        const evh_2124730035910225_success_8161 = new core_1.actions.EventHandlerImpl({
            action: act_2124730035910225_reloadSlickgrid_8162,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_2124730035910225_request_8158 = new core_1.actions.RequestAction({
            actionArgs: this.act_2124730035910225_request_8158_getActionArgs,
            displayName: "lock",
            events: [evh_2124730035910225_success_8159, evh_2124730035910225_success_8161],
        });
        const evh_2124730035910225_clickPreventStop_8157 = new core_1.actions.EventHandlerImpl({
            action: act_2124730035910225_request_8158,
            event: "click.prevent.stop",
            displayName: "lock",
        });
        const evh_2124730035910225_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2124730035910225_clickPreventStop_8157],
        });
        const act_1972474632001399_emit_8166 = new core_1.actions.EmitAction({
            actionArgs: this.act_1972474632001399_emit_8166_getActionArgs,
            events: [],
        });
        const evh_1972474632001399_success_8165 = new core_1.actions.EventHandlerImpl({
            action: act_1972474632001399_emit_8166,
            event: "success",
            displayName: "emit",
        });
        const act_1972474632001399_reloadSlickgrid_8168 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_1972474632001399_reloadSlickgrid_8168_getActionArgs,
            events: [],
        });
        const evh_1972474632001399_success_8167 = new core_1.actions.EventHandlerImpl({
            action: act_1972474632001399_reloadSlickgrid_8168,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_1972474632001399_request_8164 = new core_1.actions.RequestAction({
            actionArgs: this.act_1972474632001399_request_8164_getActionArgs,
            displayName: "lock",
            events: [evh_1972474632001399_success_8165, evh_1972474632001399_success_8167],
        });
        const evh_1972474632001399_clickPreventStop_8163 = new core_1.actions.EventHandlerImpl({
            action: act_1972474632001399_request_8164,
            event: "click.prevent.stop",
            displayName: "lock",
        });
        const evh_1972474632001399_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1972474632001399_clickPreventStop_8163],
        });
        const act_2383909669375364_emit_8172 = new core_1.actions.EmitAction({
            actionArgs: this.act_2383909669375364_emit_8172_getActionArgs,
            events: [],
        });
        const evh_2383909669375364_success_8171 = new core_1.actions.EventHandlerImpl({
            action: act_2383909669375364_emit_8172,
            event: "success",
            displayName: "emit",
        });
        const act_2383909669375364_reloadSlickgrid_8174 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_2383909669375364_reloadSlickgrid_8174_getActionArgs,
            events: [],
        });
        const evh_2383909669375364_success_8173 = new core_1.actions.EventHandlerImpl({
            action: act_2383909669375364_reloadSlickgrid_8174,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_2383909669375364_request_8170 = new core_1.actions.RequestAction({
            actionArgs: this.act_2383909669375364_request_8170_getActionArgs,
            displayName: "lock",
            events: [evh_2383909669375364_success_8171, evh_2383909669375364_success_8173],
        });
        const evh_2383909669375364_clickPreventStop_8169 = new core_1.actions.EventHandlerImpl({
            action: act_2383909669375364_request_8170,
            event: "click.prevent.stop",
            displayName: "lock",
        });
        const evh_2383909669375364_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2383909669375364_clickPreventStop_8169],
        });
        const act_2342151935932928_emit_8178 = new core_1.actions.EmitAction({
            actionArgs: this.act_2342151935932928_emit_8178_getActionArgs,
            events: [],
        });
        const evh_2342151935932928_success_8177 = new core_1.actions.EventHandlerImpl({
            action: act_2342151935932928_emit_8178,
            event: "success",
            displayName: "emit",
        });
        const act_2342151935932928_reloadSlickgrid_8180 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_2342151935932928_reloadSlickgrid_8180_getActionArgs,
            events: [],
        });
        const evh_2342151935932928_success_8179 = new core_1.actions.EventHandlerImpl({
            action: act_2342151935932928_reloadSlickgrid_8180,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_2342151935932928_request_8176 = new core_1.actions.RequestAction({
            actionArgs: this.act_2342151935932928_request_8176_getActionArgs,
            displayName: "lock",
            events: [evh_2342151935932928_success_8177, evh_2342151935932928_success_8179],
        });
        const evh_2342151935932928_clickPreventStop_8175 = new core_1.actions.EventHandlerImpl({
            action: act_2342151935932928_request_8176,
            event: "click.prevent.stop",
            displayName: "lock",
        });
        const evh_2342151935932928_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2342151935932928_clickPreventStop_8175],
        });
        const act_2498310591257107_emit_8182 = new core_1.actions.EmitAction({
            actionArgs: this.act_2498310591257107_emit_8182_getActionArgs,
            events: [],
        });
        const evh_2498310591257107_success_8181 = new core_1.actions.EventHandlerImpl({
            action: act_2498310591257107_emit_8182,
            event: "success",
            displayName: "emit",
        });
        const evh_2498310591257107_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2498310591257107_success_8181],
        });
        return {
            act_8358196963355853_script_8154,
            evh_8358196963355853_input_8153,
            evh_8358196963355853_input,
            act_4576710983066270_emit_8156,
            evh_4576710983066270_clickPreventStop_8155,
            evh_4576710983066270_clickPreventStop,
            act_2124730035910225_emit_8160,
            evh_2124730035910225_success_8159,
            act_2124730035910225_reloadSlickgrid_8162,
            evh_2124730035910225_success_8161,
            act_2124730035910225_request_8158,
            evh_2124730035910225_clickPreventStop_8157,
            evh_2124730035910225_clickPreventStop,
            act_1972474632001399_emit_8166,
            evh_1972474632001399_success_8165,
            act_1972474632001399_reloadSlickgrid_8168,
            evh_1972474632001399_success_8167,
            act_1972474632001399_request_8164,
            evh_1972474632001399_clickPreventStop_8163,
            evh_1972474632001399_clickPreventStop,
            act_2383909669375364_emit_8172,
            evh_2383909669375364_success_8171,
            act_2383909669375364_reloadSlickgrid_8174,
            evh_2383909669375364_success_8173,
            act_2383909669375364_request_8170,
            evh_2383909669375364_clickPreventStop_8169,
            evh_2383909669375364_clickPreventStop,
            act_2342151935932928_emit_8178,
            evh_2342151935932928_success_8177,
            act_2342151935932928_reloadSlickgrid_8180,
            evh_2342151935932928_success_8179,
            act_2342151935932928_request_8176,
            evh_2342151935932928_clickPreventStop_8175,
            evh_2342151935932928_clickPreventStop,
            act_2498310591257107_emit_8182,
            evh_2498310591257107_success_8181,
            evh_2498310591257107_success,
            reload: act_4576710983066270_emit_8156,
            lock: act_2342151935932928_request_8176,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcRegisterEntryHeader.prototype, "entry", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('entry'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcRegisterEntryHeader.prototype, "onEntry", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], UcRegisterEntryHeader.prototype, "selectRegister", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('selectRegister'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcRegisterEntryHeader.prototype, "onSelect_register", null);
UcRegisterEntryHeader = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcRegisterEntryHeader);
exports.default = UcRegisterEntryHeader;
vue_property_decorator_1.Vue.component("UcRegisterEntryHeader", UcRegisterEntryHeader);
